export default class SubmissionApi {

    /**
     * Create Submission
     *
     * @param data
     * @param isAuthor
     * @returns {function(*)}
     */
    static createSubmission(data, isAuthor) {
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        };

        let body = new FormData();
        Object.keys(data).forEach(( key ) => {
            body.append(key, Array.isArray(data[key])
                ? JSON.stringify(data[key])
                : data[key]
            );
        });

        body.append('isAuthor', isAuthor);

        return axios => axios.post('/submissions', body, config);
    }

    /**
     * Find all instances of the model matched by filter from the data source
     *
     * @param filter
     * @returns {Object}
     */
    static find(filter) {
        return axios => axios.get('/submissions', { filter });
    }

    /**
     * @returns {Object}
     */
    static findStatuses() {
        return axios => axios.get('/submissions/statuses');
    }

    /**
     * @returns {Object}
     */
    static findPhases() {
        return axios => axios.get('/submissions/phases');
    }

    /**
     * Get submission information
     *
     * @param id
     * @returns {function(*): *}
     */
    static loadSubmissionData(id) {
        return axios => axios.get(`/submissions/${id}`);
    }

    /**
     * Add Submission comment
     *
     * @param data
     * @returns {function(*)}
     */
    static addComment(data) {
        return axios => axios.post('/submissions/comment', data);
    }

    /**
     * Get submission comments
     *
     * @param filter
     * @returns {function(*): *}
     */
    static loadSubmissionComments(filter) {
        return axios => axios.get('/submissions/comments', { filter });
    }

    /**
     * Get submission`s article version history
     *
     * @param filter
     * @returns {function(*): *}
     */
    static loadVersionHistoryData(filter) {
        return axios => axios.get('/submissions/versions', { filter });
    }

    /**
     * Get last attachment`s version
     *
     * @param filter
     * @param isReviewer
     * @returns {function(*): *}
     */
    static loadAttachmentsData(filter, isReviewer) {
        return axios => axios.get('/submissions/version', { filter, isReviewer });
    }

    static changeStatus(id, status) {
        return axios => axios.patch(`/submissions/status/${id}`, status);
    }

    static changePhase(id, phase) {
        return axios => axios.patch(`/submissions/phase/${id}`, phase);
    }

    /**
     * Add Submission file
     *
     * @param id
     * @param data
     * @returns {function(*)}
     */
    static addSubmissionFile(id, data) {
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        };

        let body = new FormData();
        body.append(data.type, data.data);
        body.append('round', data.round);
        return axios => axios.post(`/submissions/file/${id}`, body, config);
    }

    /**
     * @param id
     * @returns {function(*): *}
     */
    static loadSubmissionActivities(id) {
        return axios => axios.get(`/submissions/activities/${id}`);
    }

    /**
      * Assign reviewers
      *
      * @param data
      * @returns {function(*)}
      */
    static assignReviewers(data) {
        return axios => axios.post('/submissions/assign', data);
    }

    /**
     * Invite external reviewers
     *
     * @param data
     * @returns {function(*)}
     */
    static inviteExternalReviewers(data) {
        return axios => axios.post('/submissions/invitations/external', data);
    }

    /**
     * @param id
     * @param decision
     * @returns {function(*): (Promise<ApiResponse<any>> | AxiosPromise<any>)}
     */
    static authorDecision(id, decision) {
        return axios => axios.patch(`/submissions/decision/${id}`, decision);
    }
}



// WEBPACK FOOTER //
// ./src/api/submission.js